import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { WizardContent } from 'components/wizard/WizardContent';
import { CreateModelStep1FormData } from 'pages/Models/AnalyticsModelTab/CreateModelStep1';
import { CreateModelStep2FormData } from 'pages/Models/AnalyticsModelTab/CreateModelStep2';
import { CreateModelStep3FormData } from 'pages/Models/AnalyticsModelTab/CreateModelStep3';
import {
    FeatureIndicatorsSection,
    Section,
    SmartIndicatorsSection,
} from 'pages/Models/AnalyticsModelTab/shared';
import styled from 'styled-components';

const Details = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
    column-gap: 1rem;
    row-gap: 1rem;
    font-size: 14px;
    align-items: top;
    margin-bottom: 2rem;
`;

const DetailLabel = styled.div`
    font-weight: bold;
`;

const DetailValue = styled.div``;

const List = styled.ul`
    font-size: 14px;

    li + li {
        margin-top: 0.5rem;
    }
`;

export type CreateModelStep4FormData = CreateModelStep1FormData &
    CreateModelStep2FormData &
    CreateModelStep3FormData;

export type CreateModelStep3Props = Readonly<{
    data: CreateModelStep4FormData;
    onCancel: () => void;
    onBack: () => void;
    onComplete: () => void;
}>;

export function CreateModelStep4({
    data: {
        name,
        version,
        timeIntervalMinutes,
        parameters,
        featureIndicators,
        smartIndicators,
    },
    onCancel,
    onBack,
    onComplete,
}: CreateModelStep3Props) {
    return (
        <WizardContent
            canCancel
            canProceed
            onCancel={onCancel}
            onBack={onBack}
            nextButtonLabel="Complete"
            onNext={onComplete}
        >
            <Section>Model Details</Section>
            <Details>
                <DetailLabel>Name:</DetailLabel>
                <DetailValue>{name}</DetailValue>

                <DetailLabel>Version:</DetailLabel>
                <DetailValue>{version}</DetailValue>

                <DetailLabel>Source Code:</DetailLabel>
                <DetailValue>
                    <FontAwesomeIcon icon={faCheck} />
                </DetailValue>

                <DetailLabel>Time Interval:</DetailLabel>
                <DetailValue>{timeIntervalMinutes} minutes</DetailValue>
            </Details>

            <Section>Parameters</Section>
            <List>
                {parameters.map(({ key, label, type, isRequired }) => (
                    <li key={key}>
                        {label} ({isRequired ? 'required' : 'optional'} {type})
                    </li>
                ))}
            </List>

            <FeatureIndicatorsSection />
            <List>
                {featureIndicators.map(({ key, name: indicatorName, unit }) => (
                    <li key={key}>
                        {indicatorName} {unit ? `(${unit})` : ''}
                    </li>
                ))}
            </List>

            <SmartIndicatorsSection />
            <List>
                {smartIndicators.map(({ key, name: indicatorName, unit }) => (
                    <li key={key}>
                        {indicatorName} {unit ? `(${unit})` : ''}
                    </li>
                ))}
            </List>
        </WizardContent>
    );
}
